import { WEEK_DAY_ENUM } from "@/static/weekDayEnum";
import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../../GenericTableResponse";

export class EditAutoInvoiceSetting {
  @Expose()
  @IsBoolean()
  autoInvoiceEnabled!: boolean;

  @IsString()
  @Expose()
  activeFrom!: string;

  @IsString()
  @IsOptional()
  @Expose()
  activeTo!: string | null;

  @Expose()
  @IsBoolean()
  autoInvoiceInBookingCurrency!: boolean;

  @Expose()
  @IsArray()
  allowedBookingItemCurrencies: string[] = [];

  @Expose()
  @IsBoolean()
  autoGenerateInvoice!: boolean;

  @Expose()
  @IsNumber()
  invoiceSettingSelected!: number;

  @Expose()
  @IsOptional()
  @IsArray()
  @IsEnum(WEEK_DAY_ENUM, { each: true })
  selectedDaysOfWeek!: Array<WEEK_DAY_ENUM> | null;

  @Expose()
  @IsOptional()
  @IsArray()
  selectedDaysOfMonth!: Array<number> | null;

  @Expose()
  @IsOptional()
  @IsArray()
  attributePrototypesChosen!: Array<AutoInvoiceAttribute> | null;

  @Expose()
  @IsOptional()
  @IsArray()
  filtrationAttributes!: Array<AutoInvoiceAttribute> | null;

  @Expose()
  @IsBoolean()
  isInverseAttributeFiltrationEnabled!: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  emailAddressNotifications!: string | null;

  @Expose()
  @IsBoolean()
  enableToDate!: boolean;
}

export class AutoInvoiceSetting extends EditAutoInvoiceSetting {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsNumber()
  recordStampId!: number;
}

export class AutoInvoiceAttribute {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsString()
  value!: string;
}

export class AutoInvoiceServiceType {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsNumber()
  @IsOptional()
  documentTypeId!: number | null;
  @Expose()
  @IsString()
  documentType!: string;
}

export class AutoInvoiceServiceTypeResponse extends GenericTableResponse<AutoInvoiceServiceType> {
  @Expose()
  @IsArray()
  @Type(() => AutoInvoiceServiceType)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<AutoInvoiceServiceType>;
}
